import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    story: {
      title: 'null'
    },
    location: {
      id: 0,
      name: ''
    },
    progress: {
      episode: 0,
      chapter: 0,
      number_of_stories: 0,
      welcome: true,
      finished: false,
      episode_interval: 60,
      debug: false,
      fades: [],
      episodeEnded: 0
    },
    user: false,
    locations: {
      1: {
        lat: null,
        lon: null
      },
      2: {
        lat: null,
        lon: null
      },
      3: {
        lat: null,
        lon: null
      },
      4: {
        lat: null,
        lon: null
      },
      5: {
        lat: null,
        lon: null
      },
      6: {
        lat: null,
        lon: null
      }
    }
  },
  mutations: {
    titleUpdate (state, title) {
      state.story.title = title
    },
    setUser (state, user) {
      if (user) {
        state.user = user
      } else {
        state.user = false
      }
    },
    setProgress (state, progress) {
      if (progress) {
        state.progress = progress
      } else {
        state.progress = false
      }
    },
    setLocation (state, locations) {
      if (locations) {
        state.locations = locations
      } else {
        state.locations = false
      }
    }
  },
  actions: {
    setProgress (context, progress) {
      context.commit('setProgress', progress)
    },
    firebaseFallback (context, target) {
      var path = target.path.split('.')
      var newpath = ''
      for (var i = 0; i < path.length; i++) {
        if (i === 0) {
          newpath = newpath + path[i] + ']'
        } else if (i === path.length - 1) {
          newpath = newpath + '[' + path[i]
        } else {
          newpath = newpath + '[' + path[i] + ']'
        }
      }
      console.log(context.state[target.path])
      context.state[target.path] = target.data
    }
  },
  getters: {
    progress: (state) => {
      return state.progress
    },
    locations: (state) => {
      return state.locations
    }
  }
})
export default store
